import {
    FETCH_USER_STATS_WELLNESS_DAILY,
    FETCH_USER_STATS_WELLNESS_DAILY_FETCHING,
    FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_DAILY_FAIL,
    FETCH_USER_STATS_WELLNESS_WEEKLY,
    FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING,
    FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL,
    FETCH_USER_STATS_WELLNESS_MONTHLY,
    FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING,
    FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    userStatsWellnessDaily: {},
    userStatsWellnessWeekly: {},
    userStatsWellnessMonthly: {},
    userStatsWellnessDailyFetching: false,
    userStatsWellnessDailyFetchFail: false,
    userStatsWellnessWeeklyFetching: false,
    userStatsWellnessWeeklyFetchFail: false,
    userStatsWellnessMonthlyFetching: false,
    userStatsWellnessMonthlyFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchUserStatsWellnessDailyFetching = (state) => {
    return {
        ...state,
        userStatsWellnessDailyFetching: true,
        userStatsWellnessDailyFetchFail: false
    };
};

const fetchUserStatsWellnessDailySuccess = (state, action) => {
    const oldMetricsMap = state.userStatsWellnessDaily;
    const newMetricsMap = action.userStatsWellnessDaily.allMetrics.metricsMap;
    const dateKey = 'calendarDate';

    let userStatsWellnessDaily = getUserStatsWellness(oldMetricsMap, newMetricsMap, dateKey);

    return {
        ...state,
        userStatsWellnessDaily: userStatsWellnessDaily,
        userStatsWellnessDailyFetching: false,
        userStatsWellnessDailyFetchFail: false
    };
};

const fetchUserStatsWellnessDailyFail = (state) => {
    return {
        ...state,
        userStatsWellnessDailyFetching: false,
        userStatsWellnessDailyFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchUserStatsWellnessWeeklyFetching = (state) => {
    return {
        ...state,
        userStatsWellnessWeeklyFetching: true,
        userStatsWellnessWeeklyFetchFail: false
    };
};

const fetchUserStatsWellnessWeeklySuccess = (state, action) => {
    const oldMetricsMap = state.userStatsWellnessWeekly;
    const newMetricsMap = action.userStatsWellnessWeekly.allMetrics.metricsMap;
    const dateKey = 'startDateOfWeek';

    let userStatsWellnessWeekly = getUserStatsWellness(oldMetricsMap, newMetricsMap, dateKey);

    return {
        ...state,
        userStatsWellnessWeekly: userStatsWellnessWeekly,
        userStatsWellnessWeeklyFetching: false,
        userStatsWellnessWeeklyFetchFail: false
    };
};

const fetchUserStatsWellnessWeeklyFail = (state) => {
    return {
        ...state,
        userStatsWellnessWeeklyFetching: false,
        userStatsWellnessWeeklyFetchFail: true
    };
};

// If there's already user metrics in the store, blend the new and old data together, else add all of the new data
// This way you can request any daily, weekly, or monthly metrics with varying time frames and have it all stored together for pagination
const getUserStatsWellness = (oldMetricsMap, newMetricsMap, dateKey) => {
    let userStatsWellness = JSON.parse(JSON.stringify(oldMetricsMap));

    if (Object.keys(oldMetricsMap).length > 0) {
        Object.keys(newMetricsMap).map((newMetric) => {
            // Blend together old and new data from the same metric
            if (oldMetricsMap[newMetric]) {
                let blendedMetrics = [...oldMetricsMap[newMetric], ...newMetricsMap[newMetric]];
                let filteredMetrics = removeDuplicates(blendedMetrics, dateKey);
                let sortedMetrics = sortByDate(filteredMetrics, dateKey);

                userStatsWellness[newMetric] = sortedMetrics;
            }
            // Add totally new metrics to the pre-existing ones
            else {
                userStatsWellness[newMetric] = newMetricsMap[newMetric];
            }
        });
    }
    // No previous data, add the all of the metrics from the fetch
    else {
        userStatsWellness = newMetricsMap;
    }

    return userStatsWellness;
};

// Remove duplicates that have the same value on the provided date key
const removeDuplicates = (originalArray, dateKey) => {
    let trimmedArray = [];
    let values = [];
    let value;

    for (let i = 0, len = originalArray.length; i < len; i++) {
        value = originalArray[i][dateKey];

        if (values.indexOf(value) === -1) {
            trimmedArray.push(originalArray[i]);
            values.push(value);
        }
    }

    return trimmedArray;
};

const sortByDate = (arrayToSort, dateKey) => {
    let sortedArray = arrayToSort.sort((a, b) => {
        return new Date(a[dateKey]) - new Date(b[dateKey]);
    });

    return sortedArray;
};

// ======= Monthly Fetching Handlers =======
const fetchUserStatsWellnessMonthlyFetching = (state) => {
    return {
        ...state,
        userStatsWellnessMonthlyFetching: true,
        userStatsWellnessMonthlyFetchFail: false
    };
};

const fetchUserStatsWellnessMonthlySuccess = (state, action) => {
    return {
        ...state,
        userStatsWellnessMonthly: action.userStatsWellnessMonthly.allMetrics.metricsMap,
        userStatsWellnessMonthlyFetching: false,
        userStatsWellnessMonthlyFetchFail: false
    };
};

const fetchUserStatsWellnessMonthlyFail = (state) => {
    return {
        ...state,
        userStatsWellnessMonthlyFetching: false,
        userStatsWellnessMonthlyFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_USER_STATS_WELLNESS_DAILY_FETCHING]: fetchUserStatsWellnessDailyFetching,
    [FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS]: fetchUserStatsWellnessDailySuccess,
    [FETCH_USER_STATS_WELLNESS_DAILY_FAIL]: fetchUserStatsWellnessDailyFail,
    [FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING]: fetchUserStatsWellnessWeeklyFetching,
    [FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS]: fetchUserStatsWellnessWeeklySuccess,
    [FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL]: fetchUserStatsWellnessWeeklyFail,
    [FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING]: fetchUserStatsWellnessMonthlyFetching,
    [FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS]: fetchUserStatsWellnessMonthlySuccess,
    [FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL]: fetchUserStatsWellnessMonthlyFail
};

// ======= Default Action ======
export default function userStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchUserStatsWellnessDaily(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_USER_STATS_WELLNESS_DAILY,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchUserStatsWellnessWeekly(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_USER_STATS_WELLNESS_WEEKLY,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchUserStatsWellnessMonthly(payload, evictCache) {
    return {
        payload,
        type: FETCH_USER_STATS_WELLNESS_MONTHLY,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getUserStatsWellnessDaily = (state) => {
    return state.userStats.userStatsWellnessDaily ? state.userStats.userStatsWellnessDaily : null;
};

export const isUserStatsWellnessDailyFetching = (state) => {
    return state.userStats.userStatsWellnessDailyFetching;
};

export const didUserStatsWellnessDailyFetchFail = (state) => {
    return state.userStats.userStatsWellnessDailyFetchFail;
};

export const getUserStatsWellnessWeekly = (state) => {
    return state.userStats.userStatsWellnessWeekly ? state.userStats.userStatsWellnessWeekly : null;
};

export const isUserStatsWellnessWeeklyFetching = (state) => {
    return state.userStats.userStatsWellnessWeeklyFetching;
};

export const didUserStatsWellnessWeeklyFetchFail = (state) => {
    return state.userStats.userStatsWellnessWeeklyFetchFail;
};

export const getUserStatsWellnessMonthly = (state) => {
    return state.userStats.userStatsWellnessMonthly ? state.userStats.userStatsWellnessMonthly : null;
};

export const isUserStatsWellnessMonthlyFetching = (state) => {
    return state.userStats.userStatsWellnessMonthlyFetching;
};

export const didUserStatsWellnessMonthlyFetchFail = (state) => {
    return state.userStats.userStatsWellnessMonthlyFetchFail;
};
